import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { ClipboardList } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function ArchitectsEngineersStagesPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Etapas e Cronograma"
      description="Acompanhe as etapas e o cronograma dos seus projetos."
      icon={ClipboardList}
    />
  
    </MainLayout>);
}

